export const ADDIN_PANE_OFFSET = 86;